export default __webpack_public_path__ + "i18n/translations/translation-mr.71e8e9dd.json";